const changeUserMarketType = {
  state: {
    companyLeixing: {}
  },
  mutations: {
    SET_COMPANYLEIXING (state, companyLeixing) {
      state.companyLeixing = companyLeixing
    }
  }
}

export default changeUserMarketType



// WEBPACK FOOTER //
// ./src/store/modules/changeUserMarketType.js